var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"wbw"},_vm._l((_vm.revealed),function(w,i){return _c('span',{key:i,staticClass:"fade-word",domProps:{"innerHTML":_vm._s(w)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }